import { Component, Injector, OnInit } from '@angular/core';
import { ImportacaoListaModule } from './importacaolista.module';
import { ListaSimplesGenerica } from '../../generic/listagenerica/listasimplesgenerica';
import { ImportacaoDocumento } from 'src/app/model/importacao/importacaoDocumento';
import { ImportacaoDocumentoService } from 'src/app/services/importacao/importacao-documento.service';

@Component({
  selector: 'app-lista-funcao',
  templateUrl: '../../generic/listagenerica/listasimples.component.html',
  styleUrls: [ '../../generic/listagenerica/listasimples.component.css']
})

export class ListaImportacaoDocumentoComponent extends ListaSimplesGenerica<ImportacaoDocumento> implements OnInit {

  override obj = new ImportacaoDocumento();

  constructor(
    injectorObj: Injector,
    api: ImportacaoDocumentoService) 
  {
    super(injectorObj, api);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  dataExtraList(res: any) {
  }

  override getColorCell(valor: any) {   
  }
  
}
